import { dateProvider } from '@utils';
import { t } from 'i18next';

export const getLiveRecordRelativeTimeString = (createdAt: Date): string => {
  const now = new Date();
  const date = new Date(createdAt);

  const days = dateProvider.diff(date, now, 'days');
  const months = dateProvider.diff(date, now, 'months');
  const years = dateProvider.diff(date, now, 'years');

  if (days < 1) return t('RECORDING_TODAY');
  if (days < 7) return t('RECORDING_DAYS', { count: days });
  if (months < 1) {
    const weeks = Math.floor(days / 7);
    return t('RECORDING_WEEKS', { count: weeks });
  }
  if (years < 1) return t('RECORDING_MONTHS', { count: months });
  return t('RECORDING_YEARS', { count: years });
};
